import { render, staticRenderFns } from "./RefundHandle.vue?vue&type=template&id=5a358698&"
import script from "./RefundHandle.vue?vue&type=script&lang=js&"
export * from "./RefundHandle.vue?vue&type=script&lang=js&"
import style0 from "./RefundHandle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports